import { action, computed, makeObservable, observable } from 'mobx';

import ApiService from '../../services/ApiService';
import { EInvoiceSupplier } from '../models/EInvoiceSupplier';
import { Loadable } from '../models/Loadable';

export default class EInvoiceSuppliersDataStore {
  @observable
  public eInvoiceSuppliers: Loadable<EInvoiceSupplier[]> = new Loadable<EInvoiceSupplier[]>();

  constructor(private apiService: ApiService) {
    makeObservable(this);
  }

  @action
  public async tryLoadEInvoiceSuppliers(): Promise<any> {
    if (!this.eInvoiceSuppliers.isInitial) {
      await this.eInvoiceSuppliers.promise;
      return;
    }
    const eInvoiceSuppliers = this.apiService.getEInvoiceSuppliers();
    this.eInvoiceSuppliers = Loadable.toLoadable(eInvoiceSuppliers);
    await eInvoiceSuppliers;
  }

  @computed
  public get banks(): EInvoiceSupplier[] {
    return this.eInvoiceSuppliers.payload.filter((eInvoiceSupplier) => eInvoiceSupplier.type === 'INTERNET_BANK');
  }

  @computed
  public get invoiceCentrals(): EInvoiceSupplier[] {
    return this.eInvoiceSuppliers.payload.filter((eInvoiceSupplier) => eInvoiceSupplier.type === 'PORTAL');
  }
}
